<div class="w-full">
    
    <div class="zuper-dialog-header justify-between border-b border-b-gray-300  header-custom-class">
        <div class="flex items-center">
            <h6 mat-dialog-title class="font-semibold primary-font">{{data?.data?.title | translate}}</h6>
        </div>
    </div>

    <!-- Body -->
    <div class="flex flex-col">
        <div class="zuper-dialog-body primary-font flex">
            <div class="flex flex-row w-full pr-4">
                <!-- Left Column -->
                <div class="flex flex-col">
                    <!-- Radio Button 1 -->
                    <div class="mb-4 flex items-center">
                        <input type="radio" id="option1" name="options" class="mr-2 cursor-pointer"
                            [(ngModel)]="updateJobCategoryAction" value="UPDATE">
                        <label for="option1" class="font-normal cursor-pointer"> {{data?.data?.updateKey | translate}}</label>
                    </div>

                    <!-- Radio Button 2 -->
                    <div class="flex items-center">
                        <input type="radio" id="option2" name="options" class="mr-2 cursor-pointer"
                             [(ngModel)]="updateJobCategoryAction" value="RETAIN">
                        <label for="option2" class="font-normal cursor-pointer"> {{data?.data?.retainKey | translate}}</label>
                    </div>
                </div>
            </div>

        </div>
        <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
            <div class="space-x-3">
                <button  (click)="updateCategory()"
                    class="btn-small bg-primary px-6 items-center py-2  shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
                    {{'proceed' | translate}}</button>
            </div>
        </div>
    </div>
</div>